var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHerond = function SvgHerond(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 126,
    viewBox: "0 0 120 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3989_34615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.551 40.3992C108.625 43.7544 113.21 51.1488 112.075 65.7792C110.573 85.1184 94.7643 113.659 58.7356 113.566C25.9907 113.486 2.70922 85.6008 7.05653 52.1856C10.8434 23.0832 29.1667 12.4344 41.5907 8.42401C33.5643 11.0088 23.1954 15.3432 12.6038 29.3688C6.84814 37.0296 2.99665 45.972 1.38707 55.4256C-4.20335 88.164 17.7487 119.246 50.4218 124.848C83.0949 130.45 116.537 107.431 119.749 73.3824C121.962 49.9176 108.23 40.6368 104.558 40.3992H104.551Z",
    fill: "url(#paint0_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.551 40.3992C108.625 43.7544 113.21 51.1488 112.075 65.7792C110.573 85.1184 94.7643 113.659 58.7356 113.566C25.9907 113.486 2.70922 85.6008 7.05653 52.1856C10.8434 23.0832 29.1667 12.4344 41.5907 8.42401C33.5643 11.0088 23.1954 15.3432 12.6038 29.3688C6.84814 37.0296 2.99665 45.972 1.38707 55.4256C-4.20335 88.164 17.7487 119.246 50.4218 124.848C83.0949 130.45 116.537 107.431 119.749 73.3824C121.962 49.9176 108.23 40.6368 104.558 40.3992H104.551Z",
    fill: "url(#paint1_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.551 40.3992C108.625 43.7544 113.21 51.1488 112.075 65.7792C110.573 85.1184 94.7643 113.659 58.7356 113.566C25.9907 113.486 2.70922 85.6008 7.05653 52.1856C10.8434 23.0832 29.1667 12.4344 41.5907 8.42401C33.5643 11.0088 23.1954 15.3432 12.6038 29.3688C6.84814 37.0296 2.99665 45.972 1.38707 55.4256C-4.20335 88.164 17.7487 119.246 50.4218 124.848C83.0949 130.45 116.537 107.431 119.749 73.3824C121.962 49.9176 108.23 40.6368 104.558 40.3992H104.551Z",
    fill: "url(#paint2_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.551 40.3992C108.625 43.7544 113.21 51.1488 112.075 65.7792C110.573 85.1184 94.7643 113.659 58.7356 113.566C25.9907 113.486 2.70922 85.6008 7.05653 52.1856C10.8434 23.0832 29.1667 12.4344 41.5907 8.42401C33.5643 11.0088 23.1954 15.3432 12.6038 29.3688C6.84814 37.0296 2.99665 45.972 1.38707 55.4256C-4.20335 88.164 17.7487 119.246 50.4218 124.848C83.0949 130.45 116.537 107.431 119.749 73.3824C121.962 49.9176 108.23 40.6368 104.558 40.3992H104.551Z",
    fill: "url(#paint3_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 21.0816C100.211 18.5544 83.7699 14.6592 79.8537 13.6296C77.3675 12.9744 75.4777 11.1744 74.1412 8.97119C62.9244 -9.54721 33.3124 8.97119 9.43457 8.38079C9.10403 8.37359 9.0681 8.87759 9.39864 8.92799C21.1543 10.8288 41.5903 8.43119 41.5903 8.43119C41.5903 8.43119 21.7651 13.0392 16.0094 35.64C14.8238 40.284 13.9471 47.1024 15.4921 55.2888C18.3735 70.596 31.7675 80.8992 47.4034 79.6032C35.8274 79.5672 26.0909 69.984 26.0909 53.9568C26.0909 30.7728 45.4561 23.004 55.6885 21.6216C71.1376 19.5264 94.5483 20.916 110.112 22.0248C110.716 22.068 110.874 21.2328 110.292 21.0888L110.285 21.0816Z",
    fill: "url(#paint4_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 21.0816C100.211 18.5544 83.7699 14.6592 79.8537 13.6296C77.3675 12.9744 75.4777 11.1744 74.1412 8.97119C62.9244 -9.54721 33.3124 8.97119 9.43457 8.38079C9.10403 8.37359 9.0681 8.87759 9.39864 8.92799C21.1543 10.8288 41.5903 8.43119 41.5903 8.43119C41.5903 8.43119 21.7651 13.0392 16.0094 35.64C14.8238 40.284 13.9471 47.1024 15.4921 55.2888C18.3735 70.596 31.7675 80.8992 47.4034 79.6032C35.8274 79.5672 26.0909 69.984 26.0909 53.9568C26.0909 30.7728 45.4561 23.004 55.6885 21.6216C71.1376 19.5264 94.5483 20.916 110.112 22.0248C110.716 22.068 110.874 21.2328 110.292 21.0888L110.285 21.0816Z",
    fill: "url(#paint5_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.285 21.0816C100.211 18.5544 83.7699 14.6592 79.8537 13.6296C77.3675 12.9744 75.4777 11.1744 74.1412 8.97119C62.9244 -9.54721 33.3124 8.97119 9.43457 8.38079C9.10403 8.37359 9.0681 8.87759 9.39864 8.92799C21.1543 10.8288 41.5903 8.43119 41.5903 8.43119C41.5903 8.43119 21.7651 13.0392 16.0094 35.64C14.8238 40.284 13.9471 47.1024 15.4921 55.2888C18.3735 70.596 31.7675 80.8992 47.4034 79.6032C35.8274 79.5672 26.0909 69.984 26.0909 53.9568C26.0909 30.7728 45.4561 23.004 55.6885 21.6216C71.1376 19.5264 94.5483 20.916 110.112 22.0248C110.716 22.068 110.874 21.2328 110.292 21.0888L110.285 21.0816Z",
    fill: "url(#paint6_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3827 59.3136C66.8115 65.7432 61.6953 79.3728 47.1947 79.6032C5.76236 80.2728 4.61266 20.1528 41.5899 8.42401C23.7695 13.7376 8.93123 30.5064 10.3252 53.7264C11.3025 69.9408 19.257 90.2736 46.4977 92.448C61.9181 93.6792 68.5145 85.4712 70.4618 80.4168C77.166 63.0072 60.9552 55.6416 58.3755 59.3064L58.3827 59.3136Z",
    fill: "url(#paint7_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3827 59.3136C66.8115 65.7432 61.6953 79.3728 47.1947 79.6032C5.76236 80.2728 4.61266 20.1528 41.5899 8.42401C23.7695 13.7376 8.93123 30.5064 10.3252 53.7264C11.3025 69.9408 19.257 90.2736 46.4977 92.448C61.9181 93.6792 68.5145 85.4712 70.4618 80.4168C77.166 63.0072 60.9552 55.6416 58.3755 59.3064L58.3827 59.3136Z",
    fill: "url(#paint8_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3827 59.3136C66.8115 65.7432 61.6953 79.3728 47.1947 79.6032C5.76236 80.2728 4.61266 20.1528 41.5899 8.42401C23.7695 13.7376 8.93123 30.5064 10.3252 53.7264C11.3025 69.9408 19.257 90.2736 46.4977 92.448C61.9181 93.6792 68.5145 85.4712 70.4618 80.4168C77.166 63.0072 60.9552 55.6416 58.3755 59.3064L58.3827 59.3136Z",
    fill: "url(#paint9_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3827 59.3136C66.8115 65.7432 61.6953 79.3728 47.1947 79.6032C5.76236 80.2728 4.61266 20.1528 41.5899 8.42401C23.7695 13.7376 8.93123 30.5064 10.3252 53.7264C11.3025 69.9408 19.257 90.2736 46.4977 92.448C61.9181 93.6792 68.5145 85.4712 70.4618 80.4168C77.166 63.0072 60.9552 55.6416 58.3755 59.3064L58.3827 59.3136Z",
    fill: "url(#paint10_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint11_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint12_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint13_linear_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint14_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint15_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3827 59.3136C66.8115 65.7432 61.6953 79.3728 47.1947 79.6032C5.76236 80.2728 4.61266 20.1528 41.5899 8.42401C23.7695 13.7376 8.93123 30.5064 10.3252 53.7264C11.3025 69.9408 19.257 90.2736 46.4977 92.448C61.9181 93.6792 68.5145 85.4712 70.4618 80.4168C77.166 63.0072 60.9552 55.6416 58.3755 59.3064L58.3827 59.3136Z",
    fill: "url(#paint16_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint17_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint18_radial_3989_34615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7589 35.9208C64.62 25.4736 49.1493 44.6112 48.6894 48.9816C64.7637 39.9312 85.4008 58.068 75.0679 78.4368C70.5769 87.2928 60.2655 93.3048 46.699 92.4408C38.4715 91.9152 30.8475 89.0784 24.7972 84.0888C16.8284 77.6376 11.3457 67.6296 10.4188 54.5472C8.67268 29.8368 24.6607 14.0328 40.4978 8.76961C40.8571 8.64721 41.2236 8.52481 41.59 8.42401C37.8535 9.48241 33.7361 11.2104 28.6487 14.5224C19.135 20.8296 8.55771 32.148 5.59004 50.4864C1.17088 84.672 23.59 109.519 50.6727 113.666C64.0092 115.618 78.4164 112.687 91.1924 103.543C98.8164 98.0856 104.644 90.4464 108.28 81.792C120.158 53.5608 101.188 39.0384 92.7517 35.9136L92.7589 35.9208Z",
    fill: "url(#paint19_linear_3989_34615)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3989_34615",
    x1: 47.7487,
    y1: 7.49521,
    x2: 71.4585,
    y2: 121.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#348BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0F3F99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.56144 46.9872) scale(104.896 105.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1ED1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6BA4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.81701 37.6128) scale(63.679 63.8064)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#11A4F0",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#119EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BA4F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.1104 53.0568) scale(104.896 105.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0BD0F6",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2AA0E1",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#417CD1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#1142A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3989_34615",
    x1: 43.8968,
    y1: 93.2832,
    x2: 62.745,
    y2: 1.62763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1142A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#1C4DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3364F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3184 77.8752) scale(45.4347 45.5256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF4070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.9675 29.4696) scale(87.8946 88.0704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3364F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3989_34615",
    x1: 56.9672,
    y1: 88.8768,
    x2: 15.7872,
    y2: 19.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1142AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1F60CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#348BF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7264 50.7384) scale(81.9305 82.0944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119EF0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C52C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7073 67.8024) scale(81.9305 82.0944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119EF0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1C52C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3989_34615",
    x1: 28.1097,
    y1: 2.99521,
    x2: 36.3543,
    y2: 41.1052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#348BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3989_34615",
    x1: 83.3385,
    y1: 106.942,
    x2: 29.7924,
    y2: 17.9793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1142A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C59C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#348BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3989_34615",
    x1: 31.4583,
    y1: 44.2728,
    x2: 118.359,
    y2: 119.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#1C52C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1B54C3",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#195CC6",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1568CB",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1079D3",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0A8FDD",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#02AAE9",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00B3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3989_34615",
    x1: 3.10381,
    y1: 60.2856,
    x2: 132.1,
    y2: 63.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1C52C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1763C9",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0A8EDC",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00B3ED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2619 59.3424) scale(55.0922 55.2024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#119EF0",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#119EF0",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#119EF0",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#119EF0",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#119EF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.15412 52.1856) scale(50.8671 50.9688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#119EF0",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#119EF0",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#119EF0",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#119EF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#119EF0",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#119EF0",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#119EF0",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119EF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9204 53.8776) scale(55.0132 55.1232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F83F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E63D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C83BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9F37C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6B33FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6135FC",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#394EE0",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1F5DCF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1664C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.2727 9.87841) scale(53.1665 53.2728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FF4070",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF4070",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FF4070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3989_34615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9805 52.2792) scale(99.1186 99.3168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF4070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B139B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#7B34EB",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6633FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3989_34615",
    x1: 46.4116,
    y1: 4.79521,
    x2: 53.2064,
    y2: 37.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#348BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#348BF6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#348BF6",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#348BF6",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#348BF6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#348BF6",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#348BF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3989_34615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 126,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHerond);
export default ForwardRef;